import React from "react";

import MySuhbatMark from "./MySuhbatMark";

/**
 * Product lockup: the mark, "MySuhbat" with "My" in the cabinet's teal, and
 * which app this is underneath. `compact` is the mark alone, for the
 * icon-only rail. Same lockup as the staff panel, in teal (2026-10-22).
 */
const MySuhbatLogo = ({ compact = false }) => (
  <span className="ms-lockup">
    <MySuhbatMark size={compact ? 36 : 34} />
    {!compact && (
      <span className="ms-lockup-text">
        <b>
          <em>My</em>Suhbat
        </b>
        <span className="ms-lockup-sub">Mijoz kabineti</span>
      </span>
    )}
  </span>
);

export default MySuhbatLogo;
